// extracted by mini-css-extract-plugin
module.exports = {"button_radius":"globalStyle_button_radius___ZVS6","button_radius_left_flat":"globalStyle_button_radius_left_flat__o8S5f"};